// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IActivateUserRequestModel {
    static getAttributeTypeMap() {
        return IActivateUserRequestModel.attributeTypeMap;
    }
}
IActivateUserRequestModel.discriminator = undefined;
IActivateUserRequestModel.additionalProperties = false;
IActivateUserRequestModel.attributeTypeMap = [
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
    {
        "name": "activate",
        "baseName": "activate",
        "type": "boolean"
    },
];
//# sourceMappingURL=iActivateUserRequestModel.js.map